const devBaseUrl = "http://localhost:8081";
const productionUrl = "/api";

export const baseApiUrl =
  process.env.NODE_ENV === "production" ? productionUrl : devBaseUrl;